import jQuery from 'jquery';
import * as segmentio from 'rp-analytics';

function trackCardIndexClick() {
    const $cardLinks = jQuery('.RC-meetingItem__link');

    if ($cardLinks.length > 0) {
        $cardLinks.click((e) => {
            e.preventDefault();
            const $linkElement = jQuery(e.target).closest('.RC-meetingItem__link');
            const href = $linkElement.attr('href');
            if (href) {
                segmentio.trackCardIndexClick({
                    [segmentio.TRAIT_RACE_OFFERS_AVAILABLE]: $linkElement.attr('data-offer') === '1' ? 'Yes' : 'No',
                    [segmentio.TRAIT_RACE_ID]: $linkElement.attr('data-race-id'),
                    [segmentio.TRAIT_RACE_DATE]: $linkElement.attr('data-race-date'),
                    [segmentio.TRAIT_RACE_TIME]: $linkElement.attr('data-race-time'),
                    [segmentio.RAIT_RACECOURSE]: $linkElement.attr('data-racecourse'),
                }).then(() => {
                    window.location.href = href;
                });
            }
        });
    }
}

export default function analyticsPage(traits = {}) {
    let pageTraits = {};
    let permutiveProps = { raceCard: {} };
    let hasPermutiveProps = false;

    segmentio.setCommonTraits({
        [segmentio.TRAIT_SITE_SECTION]: 'Cards',
        [segmentio.TRAIT_SITE_SUB_SECTION_1]: jQuery('[data-site-sub-section-1]').attr('data-site-sub-section-1'),
        [segmentio.TRAIT_SITE_SUB_SECTION_2]: jQuery('[data-site-sub-section-2]').attr('data-site-sub-section-2'),
    });

    const raceId = jQuery('[data-card-race-id]').attr('data-card-race-id');
    const raceDate = jQuery('[data-card-race-date]').attr('data-card-race-date');
    const raceTime = jQuery('[data-card-race-time]').attr('data-card-race-time');
    const raceDateTime = jQuery('[data-card-race-date-time]').attr('data-card-race-date-time');
    const coursename = jQuery('[data-card-coursename]').attr('data-card-coursename');

    if (raceId) {
        pageTraits[segmentio.TRAIT_RACE_ID] = raceId;
        permutiveProps.raceCard.raceId = raceId;
        hasPermutiveProps = true;
    }

    if (raceDate) {
        pageTraits[segmentio.TRAIT_RACE_DATE] = raceDate;
    }

    if (raceTime) {
        pageTraits[segmentio.TRAIT_RACE_TIME] = raceTime;
    }

    if (raceDateTime) {
        permutiveProps.raceCard.raceDate = raceDateTime;
        hasPermutiveProps = true;
    }

    if (coursename) {
        pageTraits[segmentio.TRAIT_RACECOURSE] = coursename;
        permutiveProps.raceCard.raceCourse = coursename;
        hasPermutiveProps = true;
    }

    pageTraits = {
        ...traits,
        ...pageTraits,
    };

    trackCardIndexClick();

    permutiveProps = hasPermutiveProps ? permutiveProps : {};

    const pageName = null; // not used for now
    segmentio.page(pageName, pageTraits, segmentio.page.DEFAULT_OPTIONS, permutiveProps);
}



// WEBPACK FOOTER //
// ./lib/js/analyticsPage.js